"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeJwt = decodeJwt;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
function decodeJwt(token) {
    const decoded = (0, jwt_decode_1.default)(token);
    return {
        ...decoded,
        iat: Number(decoded.iat),
        exp: Number(decoded.exp),
        userId: decoded.userId,
        roles: (decoded.roles || []),
    };
}
//# sourceMappingURL=decode-jwt.js.map